import { useState } from "react";
import { IoIosSearch } from "react-icons/io";
import { allImagesPath } from "../../../lib/constants/ConstantsData";

const ColorSelection = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
    if (searchQuery.trim()) {
      const searchUrl = `https://www.prismaticpowders.com/search/${encodeURIComponent(searchQuery.trim())}`;
      window.open(searchUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <section className="relative flex  w-full flex-col items-center justify-center bg-slate-200 px-4 py-8 sm:px-6 md:px-8">
      <div className="mx-auto w-full max-w-4xl text-center">
        <div className="mb-3 text-sm font-sfPro font-medium uppercase tracking-widest text-[#333333] md:text-base">
          COLOR SELECTION
        </div>

        <h2 className="mb-4 font-heading text-2xl font-bold uppercase tracking-tight sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
          FIND YOUR PERFECT COLOR
        </h2>

        <p className="mx-auto font-sfPro mb-8 max-w-2xl text-sm text-[#666666] md:text-base">
          Choose From A Wide Range Of Powder Coating Colors
        </p>
        <img
          className="mx-auto mb-8 w-[30%] max-w-2xl"
          src={allImagesPath.prismaticpowerImg}
          alt="color-selection"
        />

        <div className="mx-auto mb-8 flex w-full max-w-3xl items-center justify-center rounded-full bg-white p-2 shadow-lg sm:p-3 md:p-4">
          <IoIosSearch className="ml-0 sm:ml-2 text-lg text-gray-500 sm:text-2xl md:text-3xl" />
          <input
            placeholder="Search for powder coat colors..."
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="mx-1 sm:mx-2 flex-1 font-sfPro border-none p-1 text-xs outline-none sm:p-2 sm:text-base md:text-lg"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <button
            onClick={handleSearch}
            className="whitespace-nowrap rounded-full font-sfPro bg-[#E0E0E0] px-2 py-1 text-xs text-gray-700 sm:px-6 sm:py-3 sm:text-sm md:px-8 md:py-4 md:text-base">
            Search
          </button>
        </div>

        <button
          onClick={() =>
            window.open(
              "https://www.prismaticpowders.com/asia",
              "_blank",
              "noopener,noreferrer",
            )
          }
          className="transform rounded-full font-sfPro bg-black px-6 py-4 text-xs font-medium text-white transition-all duration-300 hover:scale-105 hover:shadow-lg sm:px-8 sm:py-5 sm:text-sm md:px-10 md:py-6 md:text-base"
        >
          Browse Full Color Library
        </button>
      </div>
    </section>
  );
};

export default ColorSelection;
